import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CardBody, CardFooter } from 'reactstrap';
import { Form, Button, Field } from '@cordata/buffet';

import { authorizedPyInstance } from '~/utils';
import usePatientSearch from '~/utils/patient/search/hook';

const IdentitySearchForm = ({
  afterSubmit,
}) => {
  const [hospitals, setHospitals] = useState([]);
  const [agencies, setAgencies] = useState([]);

  const {
    initialValues, validationSchema, setHasSearched, status,
  } = usePatientSearch();

  useEffect(() => {
    authorizedPyInstance
      .get('api/data/public/list-view-cs-tbl-identity-source', {
        params: {
          isPrimarySourceOfTruth: false,
          sort: 'sourceDescription',
        },
      })
      .then(r => r.data.data)
      .then((r) => {
        setHospitals(r.map(rr => ({
          label: rr.attributes.sourceDescription,
          value: rr.attributes.sourceDescription,
        })));
      });

    authorizedPyInstance
      .get('api/data/public/tbl-source-agency', {
        params: {
          sort: 'agencyCounty',
          'all-data': 1,
        },
      })
      .then(r => r.data.data)
      .then(setAgencies);
  }, []);

  return (
    <>
      <Form
        initialValues={initialValues}
        validationSchema={validationSchema}

        onSubmit={(values) => {
          afterSubmit(values);
      }}
      >
        {({
        handleReset,
      }) => (
        <>
          <CardBody className="pb-2">
            <Field name="lastName__like" placeholder="Enter Last Name" label={false} size="sm" />
            <Field name="firstName__like" placeholder="Enter First Name" label={false} size="sm" />
            <Field name="birthDate" label={false} placeholder="Enter Date of Birth ( MM/DD/YYYY )" size="sm" />
            <Field name="sourceMrns__contains" label={false} placeholder="Enter Medical Record Number" size="sm" />
            <Field
              name="sourceDescription"
              label={false}
              placeholder="Select Hospitals..."
              type="select"
              options={hospitals}
              multi
              closeMenuOnSelect={false}
              size="sm"
              className="p-0"
            />
            <Field
              name="agencyCounty"
              label={false}
              placeholder="Select PCSA county..."
              type="select"
              options={agencies}
              getOptionValue={o => o.attributes.agencyCounty}
              getOptionLabel={o => o.attributes.agencyCounty}
              size="sm"
              className="p-0"
            />
            <Field name="wkrName" label={false} placeholder="Enter Caseworker Name" size="sm" />
            <Field name="sacwisPersonId" label={false} size="sm" placeholder="Enter SACWIS Person ID" />
            <Field name="caseId" label={false} placeholder="Enter SACWIS Case ID" size="sm" />
            <Field name="providerId" label={false} placeholder="Enter Provider ID" size="sm" />
            <Field name="providerName" label={false} placeholder="Enter Placement Provider Name" size="sm" />
          </CardBody>

          <CardFooter className="d-flex">
            <div className="mr-auto">
              <Button
                color="danger"
                outline
                icon="times"
                onClick={() => {
                  handleReset(initialValues);
                  setHasSearched(false);
                }}
              >
                Reset
              </Button>
            </div>

            <div className="ml-auto">
              <Button type="submit" icon="search" disabled={status === 'loading'}>
                Search
              </Button>
            </div>
          </CardFooter>
        </>
      )}
      </Form>
    </>
  );
};

IdentitySearchForm.propTypes = {
  afterSubmit: PropTypes.func,
};

IdentitySearchForm.defaultProps = {
  afterSubmit: () => {},
};

export default IdentitySearchForm;
